import { render } from "./PreviewHeader.vue?vue&type=template&id=12001002"
import script from "./PreviewHeader.vue?vue&type=script&lang=js"
export * from "./PreviewHeader.vue?vue&type=script&lang=js"

import exportComponent from "/Users/sjoshi6/git/openmct/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__